interface Props {
  color?: string;
}
const ArrowButtonLeftMin = ({ color = 'white' }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 8L9.4566 12.5L10.5 11.4464L7.0868 8L10.5 4.55356L9.4566 3.5L5 8Z"
        fill={color}
      />
    </svg>
  );
};

export default ArrowButtonLeftMin;
